// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__SUzW0","logo":"styles_logo__9wgqC"};